export class PseudoRandomGenerator {
    // always returns same random number for the same seed
    // https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
    public static pseudoRandom(seed: number) {
        const x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
    }

    public static getSeedFromDate(date: Date): number {
        // use the day as the seed, so that on the same day workouts would be the same
        const seedFromDay = date.getDate() + date.getDate() + date.getMonth() / 1000;
        if (!seedFromDay || seedFromDay === 0) {
            throw Error('Assertion failed - seed must have a value');
        }
        return  seedFromDay;
    }

    // https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    public static shuffleArrayPseudoRandomly<T>(arrayToShuffle: T[], seed: number): T[] {
        const a = Array.from(arrayToShuffle); // make sure we don't mutate original
        for (let i = a.length - 1; i > 0; i--) {
            const uniqueSeedForCurrentPosition = seed / (i + 1);
            const pseudoRandom = PseudoRandomGenerator.pseudoRandom(uniqueSeedForCurrentPosition);
            const j = Math.floor(pseudoRandom * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }
}
